import { render, staticRenderFns } from "./ContestAuth.vue?vue&type=template&id=5a5b90ae&"
import script from "./ContestAuth.vue?vue&type=script&lang=js&"
export * from "./ContestAuth.vue?vue&type=script&lang=js&"
import style0 from "./ContestAuth.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports